/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { SortOrder, SortOrderFromJSON, SortOrderFromJSONTyped, SortOrderToJSON } from './SortOrder'

/**
 *
 * @export
 * @interface Sort
 */
export interface Sort {
  /**
   *
   * @type {string}
   * @memberof Sort
   */
  attribute: string
  /**
   *
   * @type {SortOrder}
   * @memberof Sort
   */
  order: SortOrder
}

export function SortFromJSON(json: any): Sort {
  return SortFromJSONTyped(json, false)
}

export function SortFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sort {
  if (json === undefined || json === null) {
    return json
  }
  return {
    attribute: json['attribute'],
    order: SortOrderFromJSON(json['order']),
  }
}

export function SortToJSON(value?: Sort | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    attribute: value.attribute,
    order: SortOrderToJSON(value.order),
  }
}
